import { render, staticRenderFns } from "./BirthdayCardText.vue?vue&type=template&id=f83d1f36&scoped=true&"
import script from "./BirthdayCardText.vue?vue&type=script&lang=js&"
export * from "./BirthdayCardText.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayCardText.vue?vue&type=style&index=0&id=f83d1f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83d1f36",
  null
  
)

export default component.exports